export interface DynamicProductSelector {
	readonly segmentId: string;
	readonly scopeId: string;
	readonly phrase: string;
	readonly filters: readonly FilterModel[];
}

export enum FilterType {
	TermFilter = 'TermFilter',
	RangeFilter = 'RangeFilter',
}

export type FilterModel = TermFilter | RangeFilter;

export interface TermFilter {
	readonly key: string;
	readonly type: FilterType.TermFilter;
	readonly values: readonly string[];
}

export interface RangeFilter {
	readonly key: string;
	readonly type: FilterType.RangeFilter;
	readonly from: number;
	readonly to: number;
}
